import { RefiningTypes } from "library/server-event-definitions/shared-events.mjs"
import { uniqueId } from "library/database/split-id.mjs"

export const busyStore = {}

RefiningTypes.before.handle((id, busy) => {
    busyStore[uniqueId(id)] = busy
})
